<footer class="tw:bg-ink-900 tw:text-ink-200">
	<div class="tw:mx-auto tw:max-w-7xl tw:px-4 tw:py-14 tw:sm:px-6 tw:lg:px-8">
		<div class="tw:grid tw:gap-10 tw:md:grid-cols-2 tw:lg:grid-cols-4">
			<!-- Brand -->
			<div class="tw:lg:col-span-1">
				<div class="tw:flex tw:items-center">
					<img
						[src]="brand.logoUrl"
						[alt]="brand.name"
						class="tw:h-20 tw:w-auto" />
				</div>
				<p class="tw:mt-4 tw:text-sm tw:leading-relaxed tw:text-ink-200/70">
					{{ brand.tagline }}. Mewujudkan perjalanan ibadah yang nyaman, aman, dan penuh
					berkah bersama tim berpengalaman.
				</p>
				<div class="tw:mt-5 tw:flex tw:items-center tw:gap-3">
					<a
						[href]="brand.instagram"
						target="_blank"
						rel="noopener"
						aria-label="Instagram"
						class="tw:grid tw:h-9 tw:w-9 tw:place-items-center tw:rounded-full tw:bg-white/10 tw:transition-colors tw:hover:bg-brand-600">
						<fa-icon ngSkipHydration [icon]="['fab', 'instagram']" />
					</a>
					<a
						[href]="brand.facebook"
						target="_blank"
						rel="noopener"
						aria-label="Facebook"
						class="tw:grid tw:h-9 tw:w-9 tw:place-items-center tw:rounded-full tw:bg-white/10 tw:transition-colors tw:hover:bg-brand-600">
						<fa-icon ngSkipHydration [icon]="['fab', 'facebook-f']" />
					</a>
					<a
						[href]="brand.youtube"
						target="_blank"
						rel="noopener"
						aria-label="YouTube"
						class="tw:grid tw:h-9 tw:w-9 tw:place-items-center tw:rounded-full tw:bg-white/10 tw:transition-colors tw:hover:bg-brand-600">
						<fa-icon ngSkipHydration [icon]="['fab', 'youtube']" />
					</a>
				</div>
			</div>

			<!-- Quick links -->
			<div>
				<h4 class="tw:text-sm tw:font-bold tw:uppercase tw:tracking-wider tw:text-white"
					>Informasi</h4
				>
				<ul class="tw:mt-4 tw:space-y-2.5 tw:text-sm">
					@for (item of nav; track item.path) {
						<li>
							<a
								[routerLink]="item.path"
								class="tw:text-ink-200/70 tw:transition-colors tw:hover:text-gold-300">
								{{ item.label }}
							</a>
						</li>
					}
				</ul>
			</div>

			<!-- Layanan -->
			<div>
				<h4 class="tw:text-sm tw:font-bold tw:uppercase tw:tracking-wider tw:text-white"
					>Layanan</h4
				>
				<ul class="tw:mt-4 tw:space-y-2.5 tw:text-sm">
					@for (item of layanan; track item.packageType) {
						<li>
							<a
								routerLink="/paket"
								[queryParams]="{ packageType: item.packageType }"
								class="tw:text-ink-200/70 tw:transition-colors tw:hover:text-gold-300">
								{{ item.label }}
							</a>
						</li>
					}
				</ul>
			</div>

			<!-- Kontak -->
			<div>
				<h4 class="tw:text-sm tw:font-bold tw:uppercase tw:tracking-wider tw:text-white"
					>Kontak</h4
				>
				<ul class="tw:mt-4 tw:space-y-3 tw:text-sm tw:text-ink-200/70">
					<li class="tw:flex tw:gap-2.5">
						<fa-icon
							icon="location-dot"
							class="tw:mt-0.5 tw:shrink-0 tw:text-gold-300" />
						<span>{{ brand.address }}</span>
					</li>
					<li class="tw:flex tw:gap-2.5">
						<fa-icon
							ngSkipHydration
							icon="phone"
							class="tw:mt-0.5 tw:shrink-0 tw:text-gold-300" />
						<a
							[href]="'tel:' + brand.phone"
							class="tw:transition-colors tw:hover:text-gold-300">
							{{ brand.phone }}
						</a>
					</li>
					<li class="tw:flex tw:gap-2.5">
						<fa-icon
							ngSkipHydration
							icon="envelope"
							class="tw:mt-0.5 tw:shrink-0 tw:text-gold-300" />
						<a
							[href]="'mailto:' + brand.email"
							class="tw:transition-colors tw:hover:text-gold-300">
							{{ brand.email }}
						</a>
					</li>
				</ul>
			</div>
		</div>

		<div
			class="tw:mt-12 tw:flex tw:flex-col tw:items-center tw:justify-between tw:gap-3 tw:border-t tw:border-white/10 tw:pt-6 tw:text-xs tw:text-ink-200/60 tw:sm:flex-row">
			<p>© {{ year }} {{ brand.name }}. Hak cipta dilindungi.</p>
			<p> Berizin resmi PPIU & PIHK · Terdaftar Kementerian Agama RI </p>
		</div>
	</div>
</footer>
